module.exports = __webpack_public_path__ + "static/media/cover-image.3816972d.png";


//////////////////
// WEBPACK FOOTER
// ./src/presentations/git-more-done/assets/cover-image.png
// module id = 385
// module chunks = 0